export default {
    sqs: {
        que: "Cola de mensajes: desacopla productores y consumidores. El productor deja mensajes y el consumidor los toma a su ritmo; si falla, el mensaje vuelve a la cola.",
        patron: "lineal",
        nodos: [["Productor", "servidor"], ["Cola SQS", "cola"], ["Consumidor", "funcion"], ["Dead-letter queue", "cola"]],
        pasos: ["El productor envía un mensaje a la cola y puede seguir con su trabajo.", "El consumidor pide mensajes; mientras procesa uno, este queda invisible para los demás.", "Si falla varias veces, el mensaje se aparta a la dead-letter queue para revisarlo."],
        objetos: {
            "Colas": ["Estándar (entrega al menos una vez, orden aproximado) o FIFO (orden exacto y sin duplicados).", 1],
            "Dead-letter queues": ["Cola aparte para mensajes que no se pudieron procesar tras varios intentos.", 3],
            "Mensajes": ["Cada dato enviado, de hasta 256 KB, con tiempo de retención y de visibilidad.", 1],
        },
    },
    sns: {
        que: "Mensajería de publicación y suscripción: un publicador envía un aviso a un tema y SNS lo entrega a todos los suscriptores a la vez (correo, SMS, SQS, Lambda, HTTP).",
        patron: "abanico",
        nodos: [["Publicador", "servidor"], ["Topic SNS", "campana"], ["Correo", "correo"], ["Cola SQS", "cola"], ["Función Lambda", "funcion"]],
        pasos: ["Un servicio publica un mensaje en el topic.", "SNS copia el mensaje a cada suscripción activa.", "Cada suscriptor lo recibe a su manera: correo, cola o función."],
        objetos: {
            "Topics": ["Canal al que se publica y del que se suscriben los receptores.", 1],
            "Suscripciones": ["Cada destino (correo, SMS, SQS, Lambda, HTTP) con su filtro opcional.", 2],
            "Plataformas móviles": ["Envío de notificaciones push a dispositivos (APNs, Firebase).", 1],
        },
    },
    eventbridge: {
        que: "Bus de eventos: recibe eventos de tus aplicaciones y de servicios de AWS y los enruta a quien corresponda según reglas, o los lanza con un horario.",
        patron: "abanico",
        nodos: [["Fuente de eventos", "campana"], ["Bus + Regla", "engranaje"], ["Lambda", "funcion"], ["Cola SQS", "cola"], ["Step Functions", "red"]],
        pasos: ["Un servicio, tu aplicación o un horario emite un evento.", "Las reglas del bus comparan el evento con su patrón.", "El evento se entrega a los destinos de las reglas que coinciden."],
        objetos: {
            "Buses": ["Canal que recibe eventos; hay uno por defecto y puedes crear otros.", 1],
            "Reglas": ["Patrón que selecciona eventos y los destinos a los que van.", 1],
            "Schedules": ["Ejecuciones únicas o recurrentes (como un cron) de un destino.", 0],
            "Pipes": ["Conexión punto a punto origen → filtro → destino, con transformación.", 1],
            "Schema Registry": ["Catálogo de las estructuras de los eventos para generar código.", 0],
        },
    },
    stepfunctions: {
        que: "Orquesta procesos de varios pasos como un diagrama de flujo: llama a funciones y servicios, espera, decide por condiciones y reintenta ante errores.",
        patron: "lineal",
        nodos: [["Inicio", "campana"], ["Paso 1 (Lambda)", "funcion"], ["Decisión", "red"], ["Paso 2 (servicio AWS)", "nube"]],
        pasos: ["Una ejecución comienza con una entrada.", "Cada estado hace su trabajo y pasa su salida al siguiente.", "Según una condición se elige el camino; los errores se reintentan o se manejan."],
        objetos: {
            "Máquinas de estado": ["Definición del flujo (estados y transiciones) en lenguaje ASL.", 1],
            "Ejecuciones": ["Una corrida del flujo con su historial paso a paso.", 0],
            "Actividades": ["Trabajo ejecutado por un programa tuyo, que consulta a Step Functions cuando hay tareas.", 1],
        },
    },
    mq: {
        que: "Colas y tópicos con los protocolos clásicos (ActiveMQ, RabbitMQ), para migrar aplicaciones existentes sin reescribir su mensajería.",
        patron: "lineal",
        nodos: [["Aplicación emisora", "servidor"], ["Broker (ActiveMQ / RabbitMQ)", "cola"], ["Aplicación receptora", "servidor"]],
        pasos: ["La aplicación envía el mensaje con AMQP, JMS, MQTT u otro protocolo estándar.", "El broker, administrado y con alta disponibilidad, lo guarda y lo entrega al receptor."],
        objetos: {
            "Brokers": ["El servidor de mensajería con su instancia y su modo de alta disponibilidad.", 1],
            "Configuraciones": ["Archivo de configuración versionado que se aplica al broker.", 1],
        },
    },
    appsync: {
        que: "API GraphQL administrada: el cliente pide exactamente los datos que necesita y AppSync los obtiene de varias fuentes, con actualizaciones en tiempo real.",
        patron: "lineal",
        nodos: [["Cliente", "movil"], ["API GraphQL (AppSync)", "nube"], ["Resolver", "engranaje"], ["Fuente (DynamoDB, Lambda)", "datos"]],
        pasos: ["El cliente envía una consulta GraphQL con los campos que quiere.", "AppSync la valida y asigna a cada campo su resolver.", "Los resolvers leen de las fuentes y la respuesta se arma con exactamente lo pedido."],
        objetos: {
            "APIs GraphQL": ["El esquema y el punto de entrada, con autenticación (Cognito, API key, IAM).", 1],
            "Data Sources": ["Las fuentes conectadas: DynamoDB, Lambda, bases HTTP, OpenSearch...", 3],
            "Resolvers": ["Código que traduce un campo del esquema en una llamada a una fuente.", 2],
        },
    },
    appflow: {
        que: "Mueve datos entre aplicaciones SaaS (Salesforce, Slack, Zendesk) y AWS (S3, Redshift) con flujos configurables, sin programar integraciones.",
        patron: "lineal",
        nodos: [["Aplicación SaaS", "nube"], ["Flujo AppFlow", "engranaje"], ["S3 / Redshift", "datos"]],
        pasos: ["Defines la conexión con la aplicación origen y qué campos traer.", "El flujo se ejecuta a pedido, por horario o por evento, transforma los campos y los carga en el destino."],
        objetos: {
            "Flujos": ["Origen, destino, mapeo de campos y disparador.", 1],
            "Conexiones": ["Credenciales guardadas para acceder a la aplicación SaaS.", 0],
        },
    },
    mwaa: {
        que: "Apache Airflow administrado: programas flujos de trabajo de datos como código (DAGs) y AWS opera el servidor de planificación y los workers.",
        patron: "lineal",
        nodos: [["DAGs en S3", "archivo"], ["Entorno MWAA", "reloj"], ["Workers", "servidor"], ["Servicios de datos", "datos"]],
        pasos: ["Subes tus DAGs (código Python) a un bucket de S3.", "El planificador de Airflow lee los DAGs y decide qué tareas toca ejecutar.", "Los workers corren las tareas y llaman a Glue, EMR, Redshift y otros servicios."],
        objetos: { "Entornos": ["Instalación completa de Airflow (web, planificador, workers) con su red y tamaño.", 1] },
    },
};
